export default __webpack_public_path__ + "static/media/osrcg18_2.5e0d3553.png";